import { FormEvent, useState } from 'react';

import { ITokenBuy, useApproveTokenBuyMutation } from '@entities/trades/token-buy';
import { FormItemWithError } from '@shared/components/Form';
import { useModal } from '@shared/components/Modal';

interface IProps<T> {
  tokenBuy: T;
  refetch: () => void;
}

export const ApproveTokenBuy = <T extends ITokenBuy>({ tokenBuy, refetch }: IProps<T>) => {
  const { id } = tokenBuy;

  const [actualAmount, setActualAmount] = useState(String(tokenBuy.usdt_amount));

  const [approveTokenBuy, { isLoading, isError, error, isSuccess }] = useApproveTokenBuyMutation();

  const { closeModal } = useModal();

  const handleAmountChange = (value: string) => {
    const [whole, decimal] = value.split('.');
    setActualAmount(decimal === undefined ? value : `${whole}.${decimal.slice(0, 6)}`);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const result = await approveTokenBuy({ id, actual_amount: String(actualAmount) });

      if ('data' in result) {
        closeModal();
        refetch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <h2>Approve Token Buy</h2>
      <form className='popup-form' onSubmit={handleSubmit}>
        <FormItemWithError
          name='actual_amount'
          label='Actual Amount USDT'
          isError={isError}
          error={error}
          secondName='tokenBuy'
        >
          <input
            type='text'
            name='actual_amount'
            id='actual_amount'
            value={actualAmount}
            onChange={e => handleAmountChange(e.target.value)}
          />
        </FormItemWithError>

        {isSuccess && <div className='form-success'>Successfully approved</div>}

        <div className='form-submit'>
          <button type='submit' disabled={isLoading}>
            Approve
          </button>
          <button type='button' className='secondary-btn' onClick={closeModal}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};
